export default{
    methods:{
        async getAllProducts(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.get('/settings/product_list', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async addCosting(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/assigned_user_costing', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getAllCosting(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/get_all_assigned_user_costing', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async deleteCosting(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/delete_assigned_user_costing', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getGeneralSetting(params) {
            
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/get_all_settings_by_type', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateGeneralSettings(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/update_by_setting_type', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async changePassword(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/change_password', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // Job Type API START
        async getAllJobTypes(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/get_all_settings_by_type', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async jobTypeDelete(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/delete_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async addJobType(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/add_job_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateJobType(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/update_job_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // Status API START
        async getAllTicketStatus() {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.get('/settings/get_all_ticket_status')
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async statusDelete(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/delete_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async addTicketStatus(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/add_ticket_status',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateTicketStatus(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/update_ticket_status',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // Character API START
        async getCharacterLimit() {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.get('/settings/get_character_limit')
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateCharacterLimit(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/update_by_setting_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // Permission
        async getUserPermission() {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.get('/settings/get_user_permission')
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateUserPermission(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/update_by_setting_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // Cost Approval 
        async getCostApproval() {
            return new Promise(async (resolve, reject) => {
                let params = {
                    settings_type: [
                        "cost_approval",
                    ]
                }
                const response = await this.$http.post('/settings/get_all_settings_by_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateCostApproval(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/update_by_setting_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // UserName Edit Tickets
        async getUserNameEditTickets() {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.get('/settings/get_display_user_name_edit_ticket')
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateUserNameEditTickets(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/update_by_setting_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        // Naming convention
        async getNamingConvention() {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.get('/settings/get_tickets_numbering')
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async updateNamingConvention(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/update_by_setting_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        //Template Product Naming convention
        async getProductNamingConvention(params) {
            return new Promise(async (resolve, reject) => {
                const response = await this.$http.post('/settings/get_all_settings_by_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
    }
}